import { Link, Offer, NameBanner } from '@rumblefish/ui/Rumblefish23Theme';
import {
  StyledStack,
  StyledButton,
  StyledSection,
  StyledLinkWrapper,
  SectionNameBannerStack,
} from './styles';
import { uiUxServicesData } from './UiUxServices.data';
import type { UiUxServicesProps } from './UiUxServices.types';

export const UiUxServices = ({
  offerRef,
  ...props
}: UiUxServicesProps): React.ReactElement => {
  return (
    <>
      <StyledSection width="normal">
        <StyledStack {...props}>
          <SectionNameBannerStack>
            <NameBanner type="section" text="Services" color="blue" />
          </SectionNameBannerStack>
        </StyledStack>
      </StyledSection>

      <Offer
        title={uiUxServicesData.mainText}
        description={uiUxServicesData.description}
        data={uiUxServicesData.services}
        height={'550px'}
        CustomButton={
          <StyledLinkWrapper>
            <Link to="/contact">
              <StyledButton>Book a free consultation</StyledButton>
            </Link>
          </StyledLinkWrapper>
        }
        ref={offerRef}
      />
    </>
  );
};
